import { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import Spinner from '~/js/components/Spinner';
import EventItem from '~/js/views/general/components/liv-plus/EventItem';
import categoriesData from '~/js/views/general/components/liv-plus/data/categories';

class MainView extends Component {
    constructor(props) {
        super(props);

        this.footerRef = React.createRef();

        props.setDefaultSection();
    }

    componentDidMount() {
        this.props.initialTopScroll();
    }

    categoryBlock({ type, description, img, logo }) {
        const { events } = this.props;
        const classes = ['category-row', 'row'];

        if (!events.length) {
            classes.push('no-events');
        }

        return (
            <div className={classes.join(' ')}>
                <div className="hexagon" />
                <div className={`col-lg-10 pull-right category-block ${type}`}>
                    <svg viewBox="0 0 260 300" width="260" height="300">
                        <defs>
                            <clipPath id="categoryClipPath" clipPathUnits="userSpaceOnUse">
                                <polygon points="130 0,260 75,260 225,130 300,0 225,0 75" />
                            </clipPath>
                        </defs>

                        <image
                            width="100%"
                            height="100%"
                            preserveAspectRatio="xMinYMin slice"
                            xlinkHref={img}
                            clipPath="url(#categoryClipPath)" />
                    </svg>

                    <div className="category-content">
                        <div className="category-logo">
                            <img src={logo} alt={type}/>
                        </div>
                        <p>{description}</p>
                    </div>
                </div>
            </div>
        );
    }

    scrollToRef = (ref, offSet) => () => {
        if (ref) {
            window.scrollTo({
                top: ref.current.offsetTop + offSet,
                behavior: 'smooth'
            });
        }
    }

    render() {
        const { events, tabChecked, loading, learMoreHandler, tabHandler } = this.props;
        const { cdnURL } = window.sandals_app.page;

        let eventsView = <Spinner />;

        if (!loading) {
            if (events.length) {
                eventsView = events.map((event, index) => (
                    <EventItem
                        key={index}
                        type={event.groupName.toLowerCase()}
                        eventName={event.eventName}
                        eventDate={event.livPlusEventDate}
                        eventRstCode={event.rstCode}
                        eventResorts={event.rstCodes}
                        resortInfoPlaceholder={event.resortInfo}
                        groupName={event.groupName}
                        images={event.mainImages}
                        description={event.description}
                        externalLink={event.landingPageUrl}
                        onLearMore={() => learMoreHandler(event)} />
                ));
            } else if (tabChecked) {
                eventsView = (
                    <div className={`coming-soon ${tabChecked.type}`}>
                        <span>
                            Upcoming {tabChecked.caption} Events <strong>Coming Soon</strong>
                        </span>
                    </div>
                );
            } else {
                eventsView = <div className="no-results">Currently, there are no events</div>;
            }
        }

        return(
            <Fragment>
                <div className="pages-header">
                    <div className="img-wrap">
                        <div className="img">
                            <img src={`${cdnURL}/images/general/liv-plus/uk/page-logo.png`} alt="Luxury included holiday + events" />
                        </div>
                    </div>
                </div>

                <section className="black-bg">
                    <article className="main-article">
                        <h2 className="title-10">Luxury Included<sup>&reg;</sup> holiday Plus (LIV+) Events <small>by Sandals</small></h2>
                        <div className="main-article-inner">
                            <p>Sandals Resorts, the world’s all-inclusive leader is proud to debut Luxury Included® holiday Plus (LIV+) Events. Now, you can enjoy Sandals and Beaches® incredible inclusions PLUS indulge in limited-edition events and experiences centered around six distinct areas: music, culture, sports, culinary, voluntourism, and social interests.</p>
                        </div>
                        {/* <div className="other">
                            <p>Refer a friend to any LIV+ Event and earn <strong>3,000 Sandals Select points!</strong></p>
                            <button onClick={this.scrollToRef(this.footerRef, -120)}>
                                View Offer Details
                            </button>
                        </div> */}
                    </article>
                </section>

                <div className="container">
                    <div className="enjoy-indulge">
                        <div className="column">
                            <h3 className="title-2">Enjoy</h3>
                            <p>Sandals and Beaches<sup>&reg;</sup> Resorts incredible inclusions</p>
                        </div>
                        <i className="ic ic-liv-plus" />
                        <div className="column">
                            <h3 className="title-2">Indulge</h3>
                            <p>In limited-edition events and experiences centered around six distinct areas</p>
                        </div>
                    </div>

                    <div className="text-center">
                        <ul className="tabs">
                            {categoriesData.map((el, index) => {
                                let isActive = '';

                                if ((tabChecked && el.type === tabChecked.type) || (!tabChecked && el.type === 'all')) {
                                    isActive = 'active';
                                }

                                return(
                                    <li
                                        key={index}
                                        className={`${el.type} ${isActive}`}
                                        onClick={() => tabHandler(el)}>
                                        {el.title}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>

                    {tabChecked && this.categoryBlock(tabChecked)}

                    {eventsView}
                </div>

                <div className="bottom-logo">
                    <img src={`${cdnURL}/images/general/liv-plus/liv-logo-UK.svg`} alt="Luxury included holiday + events" />
                </div>

                {/* <div ref={this.footerRef} className="page-footer">
                    <div className="logo-wrap">
                        <i className="ic ic-logo-sandals-select" />
                    </div>
                    <h3 className="title-8">Coming to a LIV+ event?</h3>
                    <h3 className="title-9">Why not bring along friends!</h3>
                    <p className="text-desc">Sandals Select members have the chance to earn <b className="show">3,000 Sandals Select points</b> for every person you refer to any LIV+ Events. Here’s how you get your referral points:</p>
                    <div className="num-block">
                        <div className="line">
                            <span className="num">1</span>
                        </div>
                        <p>You and your friends <strong>CHOOSE AN EVENT!</strong></p>
                    </div>
                    <div className="num-block">
                        <div className="line">
                            <span className="num">2</span>
                        </div>
                        <p>Give your friend your Sandals Select Number and promo code <strong>’REFER3000’</strong>.</p>
                    </div>
                    <div className="num-block">
                        <div className="line">
                            <span className="num">3</span>
                        </div>
                        <p>Tell your friend how awesome it is to be a Sandals Select Member and HAVE THEM <strong>ENROLL</strong> when you arrive to the resort.</p>
                    </div>
                    <div className="num-block">
                        <div className="line">
                            <span className="num">4</span>
                        </div>
                        <p>Call <strong>1-800-NOW-4SSG</strong> after you travel to redeem your points.</p>
                    </div>
                </div> */}
            </Fragment>
        );
    }
}

MainView.propTypes = {
    events: PropTypes.array,
    tabChecked: PropTypes.object,
    learMoreHandler: PropTypes.func,
    tabHandler: PropTypes.func,
    initialTopScroll: PropTypes.func,
    setDefaultSection: PropTypes.func,
};

MainView.defaultProps = {
    events: [],
    learMoreHandler: () => {},
    tabHandler: () => {},
    initialTopScroll: () => {},
    setDefaultSection: () => {}
};

export default MainView;
